// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.carousel-controls[data-v-6c3663fc] {

    display: flex;

    height: auto;

    flex-direction: row;

    align-items: center;

    justify-content: center;

    -moz-column-gap: 0.75rem;

         column-gap: 0.75rem
}
.carousel-controls[data-v-6c3663fc]:not(.inline) {

    position: absolute;

    width: 100%;

    padding: 1.5rem
}
.carousel-controls:not(.inline).horizontal.start[data-v-6c3663fc] {

    top: 0
}
.carousel-controls:not(.inline).horizontal.end[data-v-6c3663fc] {

    bottom: 0
}
.carousel-controls:not(.inline).vertical.start[data-v-6c3663fc] {

    left: 0
}
.carousel-controls:not(.inline).vertical.end[data-v-6c3663fc] {

    right: 0
}
.carousel-controls:not(.inline).vertical.start[data-v-6c3663fc],
      .carousel-controls:not(.inline).vertical.end[data-v-6c3663fc] {

    right: 0;

    height: 100%;

    width: auto;

    flex-direction: column;

    row-gap: 0.75rem
}
.carousel-controls-dot[data-v-6c3663fc] {

    height: 0.75rem;

    width: 0.75rem;

    cursor: pointer;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

    transition-property: all;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    transition-duration: 150ms
}
.carousel-controls-dot[data-v-6c3663fc]:not(.selected) {

    opacity: 0.6
}
.carousel-controls-dot[data-v-6c3663fc]:hover {

    opacity: 1
}
.carousel-controls-dot.round[data-v-6c3663fc] {

    border-radius: 100%
}
.carousel-controls-dot.selected[data-v-6c3663fc] {

    --tw-scale-x: 1.25;

    --tw-scale-y: 1.25;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/carousels/CarouselControls.vue"],"names":[],"mappings":";AA4DA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,uBAAA;;IAAA,wBAAA;;SAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,WAAA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAMA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAKA;;;IAAA,QAAA;;IAAA,YAAA;;IAAA,WAAA;;IAAA,sBAAA;;IAAA;AAAA;AAMA;;IAAA,eAAA;;IAAA,cAAA;;IAAA,eAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,6EAAA;;IAAA,iGAAA;;IAAA,uGAAA;;IAAA,wBAAA;;IAAA,wDAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,kBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <div :class=\"['carousel-controls', orientation, position, { inline }]\">\n    <div\n      v-for=\"i in count\"\n      :key=\"i\"\n      :class=\"['carousel-controls-dot', { round, selected: i - 1 === value }]\"\n      :style=\"i - 1 === value ? dotSelectedStyle : dotStyle\"\n      @click=\"$emit('input', i - 1)\"\n    />\n  </div>\n</template>\n\n<script>\nexport default {\n  props: {\n    value: {\n      type: Number,\n      required: true,\n    },\n\n    count: {\n      type: Number,\n      default: 0,\n    },\n\n    round: {\n      type: Boolean,\n      default: true,\n    },\n\n    orientation: {\n      type: String,\n      default: 'horizontal',\n    },\n\n    position: {\n      type: String,\n      default: 'end',\n    },\n\n    inline: {\n      type: Boolean,\n      default: false,\n    },\n\n    dotStyle: {\n      type: Object,\n      required: false,\n    },\n\n    dotSelectedStyle: {\n      type: Object,\n      required: false,\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.carousel-controls {\n  @apply h-auto flex flex-row justify-center items-center gap-x-micro;\n\n  &:not(.inline) {\n    @apply absolute w-full p-xxs;\n\n    &.horizontal {\n      &.start {\n        @apply top-0;\n      }\n\n      &.end {\n        @apply bottom-0;\n      }\n    }\n\n    &.vertical {\n      &.start {\n        @apply left-0;\n      }\n\n      &.end {\n        @apply right-0;\n      }\n\n      &.start,\n      &.end {\n        @apply right-0 h-full w-auto flex-col gap-y-micro;\n      }\n    }\n  }\n\n  &-dot {\n    @apply bg-neutral-white w-micro h-micro cursor-pointer shadow-md transition-all;\n\n    &:not(.selected) {\n      @apply opacity-60;\n    }\n\n    &:hover {\n      @apply opacity-100;\n    }\n\n    &.round {\n      @apply rounded-circular;\n    }\n\n    &.selected {\n      @apply scale-125;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
